import { useContext } from 'react'
import ToastContext, { ToastProviderOptions } from 'context/ToastContext'

export default function useToast() {
  return useContext(ToastContext) as ToastProviderOptions
}
